import makeStyles from '@material-ui/core/styles/makeStyles';
import {getDate} from '../../../../../../@casino/lib/getDate';

const useStyles = makeStyles(() => ({
    wrapTitle: {
        paddingLeft: 8,
        paddingBottom: '6px',
        marginTop: 20,
        paddingTop: '4px',
        marginBottom: '8px',
        borderBottom: '1px solid #ccc',
        width: '97%',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: 12,
    }, 
    title: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '14px',
        lineHeight: '17px',
        userSelect: 'none',
        fontFamily: 'PT Sans,sans-serif',
        color: '#fff',
    },
    arrow: {
        fill: '#fff', 
        width: 10, 
        height: 10
    }
}))

const columns = [
    { id: 'id', label: 'ID'},
    { id: 'event_date', label: 'Дата события'},
    { id: 'login', label: 'Логин'},
    { id: 'groups', label: 'Группа'},
    { id: 'jackpot', label: 'Джекпот'},
    { id: 'amount', label: 'Сумма'}
];

const getRows = (list) => {

    return list.map((item) => {
        return {
            id: item.id,
            event_date: getDate(+item.event_date),
            login: item.login,
            groups: item.groups,
            jackpot: item.jackpot,
            amount: new Intl.NumberFormat('ru-RU').format(item.amount ? item.amount.toFixed(2) : item.amount) + '₽'
        }
    })
} 

export {
    useStyles,
    getRows,
    columns
}